/**
 * EVO — himoyalangan marshrut.
 *
 * Nima uchun `beforeLoad` da emas, komponentda:
 * sessiya `/auth/me` orqali ASINXRON tiklanadi (sahifa yangilanganda refresh
 * token bor, access token yo'q). `beforeLoad` router kontekstiga bog'lanadi va
 * u auth holati kelguncha ishga tushadi — natijada foydalanuvchi har F5 da
 * bir lahza login ekranini ko'radi. Komponent qatlami `isLoading` ni kutadi.
 *
 * ESLATMA: bu HIMOYA EMAS, faqat navigatsiya. Ma'lumot himoyasi API'da —
 * `PermissionsGuard` va `maskFields` (PERMISSION_MATRIX §4.2).
 */
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuth } from '../lib/auth';
import { useT } from '../lib/i18n-context';
import { FullPageSpinner } from './ui/spinner';

export function ProtectedRoute({ children }: { readonly children: ReactNode }): ReactNode {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const t = useT();

  useEffect(() => {
    if (isLoading || user) return;

    void navigate({
      to: '/login',
      // Qayerga kirmoqchi bo'lgani saqlanadi — login'dan keyin o'sha yerga qaytadi.
      search: { redirect: location.pathname },
      replace: true,
    });
  }, [isLoading, user, navigate, location.pathname]);

  if (isLoading) {
    return <FullPageSpinner label={t('auth.restoring')} />;
  }

  // Redirect effekt ishlagunga qadar bo'sh ekran — login formasi bir lahza
  // ko'rinib ketmasligi uchun.
  if (!user) return null;

  return children;
}
